module.exports = __webpack_public_path__ + "static/endviolence_bn_imgM@2x-312ac59fa0a767cd2b3ebe8372a5bba1.png";